import { RecentlyUpdatedBlockDetails } from 'common/api/dto/get-block.dto';
import { CsvHeaders } from 'common/components/CsvButton/CsvButton';
import { BlockStatus, ReasonEnum } from 'common/models';
import { CmsDate } from 'common/models/cmsDate';
import { toEnumLabel } from 'utils/enumFunctions';

const enum BlockChangesKey {
  status = 'status',
  lastUpdated = 'lastUpdated',
  growerId = 'growerId',
  blockId = 'blockId',
  variety = 'variety',
  acres = 'acres',
  parentGrower = 'parentGrower',
  notes = 'notes',
  inactiveReason = 'inactiveReason',
  reasonDetails = 'reasonDetails',
}

const blockChangesHeaders: CsvHeaders<BlockChangesKey>[] = [
  { label: 'Last Updated', key: BlockChangesKey.lastUpdated },
  { label: 'Grower ID', key: BlockChangesKey.growerId },
  { label: 'Block ID', key: BlockChangesKey.blockId },
  { label: 'Status', key: BlockChangesKey.status },
  { label: 'Variety', key: BlockChangesKey.variety },
  { label: 'Acres', key: BlockChangesKey.acres },
  { label: 'Parent Grower', key: BlockChangesKey.parentGrower },
  { label: 'Inactive Reason', key: BlockChangesKey.inactiveReason },
  { label: 'Reason Details', key: BlockChangesKey.reasonDetails },
  { label: 'Block Notes', key: BlockChangesKey.notes },
];

/**
 * Returns csv formated headers and rows for block changes data.
 */
export const formatBlockChangesData = (
  data: RecentlyUpdatedBlockDetails[],
): {
  headers: CsvHeaders<BlockChangesKey>[];
  rows: Record<BlockChangesKey, string>[];
} => ({
  headers: blockChangesHeaders,
  rows: data.map(
    ({
      unifiedUpdatedAt,
      grower: { growerId, parentGrowerName },
      blockId,
      variety,
      acres,
      notes,
      seasonData,
    }) => {
      return {
        status: seasonData?.status
          ? toEnumLabel(BlockStatus[seasonData?.status])
          : '',
        lastUpdated: CmsDate.parse(unifiedUpdatedAt)?.toDateString() || '',
        growerId: growerId.toString(),
        blockId: blockId.toString(),
        variety: variety?.varietyCode || '',
        acres: acres ? acres.toString() : '',
        parentGrower: parentGrowerName || '',
        notes: notes || '',
        inactiveReason: seasonData?.reason?.reason
          ? toEnumLabel(ReasonEnum[seasonData?.reason?.reason])
          : '',
        reasonDetails: seasonData?.reason?.note || '',
      };
    },
  ),
});
